import React from 'react';
import { Image } from 'react-konva';

interface propType  {
  image: any;
  x: number;
  y: number;
  onClick?: Function;
  height?: number;
  width?: number;
  rotation?: number;
  onMouseEnter?: Function;
  onMouseLeave?: Function;
}

interface stateType {
  image?: File | string | HTMLImageElement | null
}

export default class ProcessIcon extends React.Component<propType, stateType>{
  static defaultProps = {
    width: 25,
    height: 20
  }  
  constructor(props: propType){
      super(props) {
        this.state = {
          image: null
        }
      }
    }
    componentDidMount(){
      const image = new window.Image();
      image.src = this.props.image
      image.onload = () =>{
        this.setState({image})
      }
    }
    render(){
      const { x, y, height, width } = this.props
      return <Image 
      x={x}
      y={y}
      image={this.state.image}
      width={width} 
      height={height}
      rotation={this.props.rotation}
      onClick={this.props.onClick}
      onMouseEnter={this.props.onMouseEnter}
      onMouseLeave={this.props.onMouseLeave} />
    }
  }
